import {
  ADD_SLIDE,
  ADD_SLIDE_FAIL,
  ADD_SLIDE_SUCCESS,
  CHECK_BOARD_ACTIVITY,
  CREATE_BOARD,
  CREATE_BOARD_FAIL,
  CREATE_BOARD_SUCCESS,
  DELETE_BOARD,
  DELETE_BOARD_FAIL,
  DELETE_BOARD_SUCCESS,
  DELETE_SLIDE,
  DELETE_SLIDE_FAIL,
  DELETE_SLIDE_SUCCESS,
  FETCH_SLIDES,
  FETCH_SLIDES_FAIL,
  FETCH_SLIDES_SUCCESS,
  GET_BOARDS_LIST,
  GET_BOARDS_LIST_FAIL,
  GET_BOARDS_LIST_SUCCESS,
  LOGIN_TO_NOTICE_BOARD,
  LOGIN_TO_NOTICE_BOARD_FAIL,
  LOGIN_TO_NOTICE_BOARD_SUCCESS,
  RESET_NOTICE_BOARD_PASSWORD,
  RESET_NOTICE_BOARD_PASSWORD_FAIL,
  RESET_NOTICE_BOARD_PASSWORD_SUCCESS,
  UPDATE_SLIDE,
  UPDATE_SLIDE_FAIL,
  UPDATE_SLIDE_SUCCESS,
} from "./actionTypes";

export const deleteBoard = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: DELETE_BOARD,
  payload: { data, onSuccess, onError },
});
export const deleteBoardSuccess = data => ({
  type: DELETE_BOARD_SUCCESS,
  payload: data,
});
export const deleteBoardFail = data => ({
  type: DELETE_BOARD_FAIL,
  payload: data,
});

export const resetNoticeBoardPassword = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: RESET_NOTICE_BOARD_PASSWORD,
  payload: { data, onSuccess, onError },
});
export const resetNoticeBoardPasswordSuccess = data => ({
  type: RESET_NOTICE_BOARD_PASSWORD_SUCCESS,
  payload: data,
});
export const resetNoticeBoardPasswordFail = data => ({
  type: RESET_NOTICE_BOARD_PASSWORD_FAIL,
  payload: data,
});

export const checkBoardActivity = (data, headers = {}) => ({
  type: CHECK_BOARD_ACTIVITY,
  payload: { data, headers },
});

export const updateSlide = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: UPDATE_SLIDE,
  payload: { data, onSuccess, onError },
});
export const updateSlideSuccess = data => ({
  type: UPDATE_SLIDE_SUCCESS,
  payload: data,
});
export const updateSlideFail = data => ({
  type: UPDATE_SLIDE_FAIL,
  payload: data,
});

export const deleteSlide = (data, syncList) => ({
  type: DELETE_SLIDE,
  payload: { data, syncList },
});
export const deleteSlideSuccess = data => ({
  type: DELETE_SLIDE_SUCCESS,
  payload: data,
});
export const deleteSlideFail = data => ({
  type: DELETE_SLIDE_FAIL,
  payload: data,
});

export const createBoard = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: CREATE_BOARD,
  payload: { data, onSuccess, onError },
});
export const createBoardSuccess = data => ({
  type: CREATE_BOARD_SUCCESS,
  payload: data,
});
export const createBoardFail = data => ({
  type: CREATE_BOARD_FAIL,
  payload: data,
});

export const addSlide = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: ADD_SLIDE,
  payload: { data, onSuccess, onError },
});
export const addSlideSuccess = data => ({
  type: ADD_SLIDE_SUCCESS,
  payload: data,
});
export const addSlideFail = data => ({
  type: ADD_SLIDE_FAIL,
  payload: data,
});

export const getBoardsList = data => ({
  type: GET_BOARDS_LIST,
  payload: data,
});
export const getBoardsListSuccess = data => ({
  type: GET_BOARDS_LIST_SUCCESS,
  payload: data,
});
export const getBoardsListFail = data => ({
  type: GET_BOARDS_LIST_FAIL,
  payload: data,
});

export const fetchBoardSlides = (data, onSuccess = () => {}, onError = () => {}, headers = {}) => ({
  type: FETCH_SLIDES,
  payload: { data, onSuccess, onError, headers },
});
export const fetchBoardSlidesSuccess = data => ({
  type: FETCH_SLIDES_SUCCESS,
  payload: data,
});
export const fetchBoardSlidesFail = data => ({
  type: FETCH_SLIDES_FAIL,
  payload: data,
});

export const loginNoticeBoard = (data, onSuccess = () => {}, onError = () => {}) => ({
  type: LOGIN_TO_NOTICE_BOARD,
  payload: { data, onSuccess, onError },
});
export const loginNoticeBoardSuccess = data => ({
  type: LOGIN_TO_NOTICE_BOARD_SUCCESS,
  payload: data,
});
export const loginNoticeBoardFail = data => ({
  type: LOGIN_TO_NOTICE_BOARD_FAIL,
  payload: data,
});
